import $ from 'jquery';
import 'jquery-validation';
import 'jquery-validation-unobtrusive';
import enableValidationFunctionality from './validation';
/**
 * Enables the "stay informed" form functionality.
 */
const enableStayInformedFunctionality = () => {
    if ($('#stay-informed').length === 0) {
        return;
    }
    enableValidationFunctionality();
    // Handles the validation of the "stay informed" form
    $('#stay-informed-form').each(function () {
        const form = $(this);
        form.on('submit', e => {
            e.preventDefault();
            if (!form.valid()) {
                return;
            }
            _toggleSubmit(form, true);
            const serializedData = form.serializeArray();
            let emailAddress = '';
            let name = '';
            let privacyPolicy = false;
            let important = '';
            for (const field of serializedData) {
                switch (field.name) {
                    case 'StayInformedForm.Name':
                        name = field.value;
                        break;
                    case 'StayInformedForm.EmailAddress':
                        emailAddress = field.value;
                        break;
                    case 'StayInformedForm.Important':
                        important = field.value;
                        break;
                    case 'StayInformedForm.PrivacyPolicy':
                        if (field.value === 'true') {
                            privacyPolicy = true;
                        }
                        break;
                }
            }
            // exit if the "important" field is not empty or if the form data is invalid
            if ((important !== '') || !privacyPolicy || !name || !emailAddress) {
                _toggleSubmit(form, false);
                return;
            }
            $.ajax({
                data: {
                    u: '3e06197972a2f6a90d5c27fb4',
                    id: '90d2680c3c',
                    EMAIL: emailAddress,
                    MMERGE1: name,
                    b_3e06197972a2f6a90d5c27fb4_90d2680c3c: important
                },
                dataType: 'jsonp',
                jsonp: 'c',
                type: 'GET',
                url: 'https://vantisuas.us2.list-manage.com/subscribe/post-json'
            }).done((data, status) => {
                if (data && (data.result === 'error')) {
                    _toggleError('mailchimp-error', data.msg);
                    _toggleSubmit(form, false);
                }
                else if (data && (status === 'success')) {
                    form.hide();
                    _toggleSuccess('generic-msg');
                }
            }).fail(() => {
                _toggleError('generic-error');
                _toggleSubmit(form, false);
            });
        });
        form.validate();
        form.removeData('validator');
        form.removeData('unobtrusiveValidation');
        $.validator.unobtrusive.parse(form);
        _toggleSubmit(form, false);
    });
    /**
     * Toggles the displayed error message.
     * @param type - The type of error message (`generic-error` or `mailchimp-error`).
     * @param mailchimpMsg - The message from Mailchimp.
     */
    function _toggleError(type, mailchimpMsg) {
        const err = $('#stay-informed-form-error');
        // show the error div and hide any other messages
        err.show();
        $('#stay-informed-form-success').hide();
        $('> div', err).hide();
        // get the Mailchimp message and configure
        const errMsg = $(`> .${type}`, err);
        if (mailchimpMsg) {
            $('p', errMsg).empty().append(mailchimpMsg);
            $('p a', errMsg)
                .addClass('alert-link')
                .attr('target', '_blank');
        }
        // show the specified message
        errMsg.show();
    }
    /**
     * Toggles the displayed success message.
     * @param type - The type of success message (`generic-msg` or `mailchimp-msg`).
     * @param mailchimpMsg - The message from Mailchimp.
     */
    function _toggleSuccess(type, mailchimpMsg) {
        const success = $('#stay-informed-form-success');
        // show the success div and hide any other messages
        success.show();
        $('#stay-informed-form-error').hide();
        $('> div', success).hide();
        // get the Mailchimp message and configure
        const successMsg = $(`> .${type}`, success);
        if (mailchimpMsg) {
            $('p', successMsg).empty().append(mailchimpMsg);
            $('p a', successMsg)
                .addClass('alert-link')
                .attr('target', '_blank');
        }
        // show the specified message
        successMsg.show();
    }
    /**
     * Toggles whether the "submit" button is disabled.
     * @param form - The parent form of the button.
     * @param disable - Whether the button is disabled.
     */
    function _toggleSubmit(form, disable) {
        $('.btn', form).prop('disabled', disable);
    }
};
export default enableStayInformedFunctionality;
